<template>
  <div class="finance-page main-wrapper">
    <div class="finance-page__inner px-2 px-md-3 pt-2">
      <h3 class="finance-page__title">
        {{ $t('deposit.deposit_form') }}
      </h3>
      <div class="finance-panel">
        <form>
            <!-- <h6 class="heading-small text-dark">
                          {{
                              $store.state.language === "en"
                                  ? "Account information"
                                  : "အကောင့်ဆိုင်ရာ အချက်အလက်များ"
                          }}
                      </h6>
                      <span class="heading-small text-muted">{{
                                  $store.state.language === "en"
                                      ? "User's Balance"
                                      : "လက်ကျန်ငွေ"
                              }} - </span>
                      <span>
                        <b class="text-danger">{{ Number($store.state.amount).toLocaleString() }}</b>
                        <span class="text-muted pl-2">{{ $store.state.language === 'en' ? 'MMK' : 'ကျပ်' }}</span>
                      </span> -->
            <div class="pl-lg-2">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label
                      class="finance-label"
                      for="input-username"
                    >{{ $t('deposit.choose_payment_type') }}</label>
                    <AccountSelect
                      :data="selected_account"
                      field="account_id"
                      :accounts="accounts"
                    />
                    <span class="text-danger">{{
                      errors.account
                    }}</span>
                  </div>
                </div>
              </div>
              <div
                v-if="account.length !== 0"
                class="row mx-0"
              >
                <div class="col-12 p-0 py-3">
                  <div class="finance-account-card my-2 text-center">
                    <div class="finance-account-card__head text-white">
                      {{ account[0].name }}
                    </div>
                    <div class="finance-account-card__sub text-white">
                      {{ account[0].account_name }}
                    </div>
                    <h3
                      class="finance-account-card__number"
                      id="textToCopy"
                    >
                      {{ account[0].number }}
                    </h3>
                    <button
                      type="button"
                      class="finance-copy-btn"
                      @click="copyText"
                    >
                      Copy
                    </button>
                  </div>

                  <p class="finance-hint mb-0 mt-2">
                    <span class="finance-hint--warn">****</span>
                    {{ account[0].note }}
                  </p>
                </div>
              </div>
            </div>
            <!-- <hr class="my-4" />d -->
            <div class="pl-lg-2">
              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="form-group">
                    <label
                      class="finance-label"
                      for="deposit-amount-input"
                    >{{ $t('deposit.amount') }}</label>
                    <span class="finance-hint finance-hint--warn d-block mb-1">{{ $t('deposit.minimum_deposit') }}</span>
                    <input
                      id="deposit-amount-input"
                      type="number"
                      inputmode="numeric"
                      class="form-control finance-input"
                      v-model.number="depositData.amount"
                    >
                    <span class="text-danger">{{
                      errors.amount
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="row amount-buttons-row mb-4 mx-0">
                <div class="col-4 amount-button-wrap">
                  <button
                    type="button"
                    class="amount-chip"
                    :class="depositData.amount === 5000 ? 'active' : ''"
                    @click="depositCustomAmount(5000)"
                  >
                    5,000 MMK
                  </button>
                </div>
                <div class="col-4 amount-button-wrap">
                  <button
                    type="button"
                    class="amount-chip"
                    :class="depositData.amount === 10000 ? 'active' : ''"
                    @click="depositCustomAmount(10000)"
                  >
                    10,000 MMK
                  </button>
                </div>
                <div class="col-4 amount-button-wrap">
                  <button
                    type="button"
                    class="amount-chip"
                    :class="depositData.amount === 30000 ? 'active' : ''"
                    @click="depositCustomAmount(30000)"
                  >
                    30,000 MMK
                  </button>
                </div>
                <div class="col-4 amount-button-wrap">
                  <button
                    type="button"
                    class="amount-chip"
                    :class="depositData.amount === 50000 ? 'active' : ''"
                    @click="depositCustomAmount(50000)"
                  >
                    50,000 MMK
                  </button>
                </div>
                <div class="col-4 amount-button-wrap">
                  <button
                    type="button"
                    class="amount-chip"
                    :class="depositData.amount === 100000 ? 'active' : ''"
                    @click="depositCustomAmount(100000)"
                  >
                    100,000 MMK
                  </button>
                </div>
                <div class="col-4 amount-button-wrap">
                  <button
                    type="button"
                    class="amount-chip"
                    :class="depositData.amount === 300000 ? 'active' : ''"
                    @click="depositCustomAmount(300000)"
                  >
                    300,000 MMK
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-12 px-0 mt-2">
              <div class="form-group px-0">
                  <label class="finance-label">{{ $store.state.language === "en" ? "Screenshot" : "ငွေပေးချေမူ ဓာက်ပုံ" }}</label>
                  <div class="custom-file d-flex">
                      <van-uploader
                          class="mx-auto"
                          v-model="imageUploader"
                          :max-count="1"
                      />
                  </div>
                  <span class="text-danger">{{
                      errors.image
                  }}</span>
              </div>
            </div>

            <div class="pl-lg-2">
              <div class="form-group">
                <label class="finance-label">{{ $t('voucher.remark') }}</label>
                <textarea
                  class="form-control finance-input finance-textarea"
                  v-model="depositData.remark"
                  rows="3"
                />
                <span class="text-danger">{{
                  errors.remark
                }}</span>
              </div>
              <van-radio-group
                v-model="depositData.is_bonus"
                class="d-flex flex-wrap justify-content-center mb-3"
                v-if="is_promotion && $store.state.disableJson?.promotions?.is_open"
              >
                <van-radio
                  class="mx-3 my-2"
                  :name="false"
                  checked-color="#2563eb"
                >{{ $store.state.language === 'en' ? 'No Bonus Point' : 'ဘောနပ် မယူပါ။' }}</van-radio>
                <van-radio
                  class="mx-3 my-2"
                  :name="true"
                  checked-color="#2563eb"
                > {{ $store.state.language === 'en' ? 'Claim Bonus Point' : 'ဘောနပ် ယူမည်။' }} </van-radio>
              </van-radio-group>


              <div class="form-group mb-0">
                <button
                  type="button"
                  class="btn finance-btn-primary"
                  @click="sendDepositData"
                >
                  <div v-if="!isConfirm">
                    {{ $t('deposit.submit') }}
                  </div>

                  <Loading
                    color="#ffffff"
                    v-if="isConfirm"
                    size="24"
                    class="px-4 py-0"
                  />
                </button>
              </div>
            </div>

          </form>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Dialog, Loading } from 'vant';
import { mapActions } from 'vuex';
import AccountSelect from './components/AccountSelect.vue';

export default {
  components: { AccountSelect, Loading },
  data() {
    return {
      selected_account: {},
      accounts: [],
      account: [],
      imageUploader: [],
      depositData: {
        is_bonus: false,
        amount: 0
      },
      is_promotion: true,
      errors: {},
      isConfirm: false,
      testing: 0,
    };
  },
  methods: {
    ...mapActions(['fetchUser']),
    depositCustomAmount(number) {
      
      const n = Number(number);
      console.log(n);
      this.depositData.amount = n;
      console.log(this.depositData);
      // this.testing = n;
    },
    copyText() {
      // Get the text to copy
      const textToCopy = document.getElementById('textToCopy').innerText;

      // Create a temporary textarea element
      const textarea = document.createElement('textarea');
      textarea.value = textToCopy;

      // Append the textarea to the DOM
      document.body.appendChild(textarea);

      // Select the text in the textarea
      textarea.select();

      // Execute the 'copy' command
      document.execCommand('copy');

      // Remove the temporary textarea
      document.body.removeChild(textarea);

      alert('You have copy Phone Number');
    },
    async fetchAccounts() {
      try {
        const res = await axios.get('/accounts', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        this.accounts = res.data.data;
        // this.depositData.is_bonus = res.data.is_promotion;
        this.is_promotion = res.data.is_promotion;

        // Group objects by name
        // const groupedByName = this.accounts.reduce((acc, obj) => {
        //     acc[obj.name] = acc[obj.name] || [];
        //     acc[obj.name].push(obj);
        //     return acc;
        // }, {});

        // // Get a random object from each group
        // const getRandomObjectFromGroup = (group) => {
        //     const randomIndex = Math.floor(Math.random() * group.length);
        //     return group[randomIndex];
        // };

        // // Collect the random objects into a single array
        // this.accounts = Object.keys(groupedByName).map(name => getRandomObjectFromGroup(groupedByName[name]));

      } catch (error) {
        console.log(error);
      }
    },
    async sendDepositData() {
      try {
        const authUser = await this.fetchUser();
        this.errors = {};
        if (!this.selected_account.account_id) {
          this.errors.account = this.$store.state.language === 'en'
            ? 'Please pick account type'
            : 'အကောင့်အမျိုးအစား ရွေးချယ်ပေးပါ။';
          return false;
        }
        if (!this.imageUploader.length > 0) {
          this.errors.image = this.$store.state.language === 'en'
            ? 'Please insert screenshot photo'
            : 'ငွေပေးချေမူမှတ်တမ်း (screenshot) ထည့်သွင်းပါ။';
          return false;
        }
        // if (!this.depositData.remark || this.depositData.remark.length < 6) {
        //   this.errors.remark = this.$store.state.language === 'en'
        //     ? 'Please enter last transaction id 6'
        //     : 'ငွေစာရင်းနောက်ဆုံးနံပါတ်  6 လုံး ထည့်ပေးပါ။';
        //   return false;
        // }

        if (!this.depositData.amount) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'Please enter amount'
            : 'ငွေပမာဏထည့်ပေးပါ။';
          return false;
        }
        if (!this.depositData.amount) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'Please enter amount'
            : 'ငွေပမာဏထည့်ပေးပါ။';
          return false;
        }
        if (this.depositData.amount < 5000) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'Please enter at least 5,000 MMK'
            : 'ငွေပမာဏအနည်းဆုံး ၅,၀၀၀ ထည့်ပေးပါ။';
          return false;
        }
        // if (!this.depositData.remark) {
        //   this.errors.remark = this.$store.state.language === 'en'
        //     ? 'Please enter last transaction id 6'
        //     : 'Please enter last transaction id 6';
        //   return false;
        // }
        this.isConfirm = true;
        if (this.imageUploader[0]) {
          this.depositData.transaction_image = await this.compressAndConvertToWebP(this.imageUploader[0].content);
        }
        this.depositData.account_id = this.account[0].id;
        this.depositData.date = this.currentTime;
        const res = await axios.post('/deposits', this.depositData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        this.imageUploader = [];
        this.depositData = {};
        this.selected_account.account_id = null;
        Toast.success(
          this.$store.state.language === 'en'
            ? 'Success'
            : 'အောင်မြင်သည်။',
        );
        this.isConfirm = false;
      } catch (error) {
        this.isConfirm = false;
        let errorMessage = 'ငွေသွင်း၍ မရသေးပါ။ Customer service သို့ဆက်သွယ်ပေးပါ။';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        Dialog.alert({
          message: errorMessage,
          confirmButtonText:
            this.$store.state.language === 'en'
              ? 'Go Back'
              : 'နောက်သို့ပြန်သွားမည်။',
        })
      }
      return true;
    },
    createDateWithTimeZone() {
      const moment = require('moment-timezone');
      const dateInTimeZone = moment.tz(new Date(), 'Asia/Rangoon');
      // Extract individual components from moment object
      const year = dateInTimeZone.year();
      const month = dateInTimeZone.month();
      const day = dateInTimeZone.date();
      const hour = dateInTimeZone.hour();
      const minute = dateInTimeZone.minute();
      const second = dateInTimeZone.second();
      const millisecond = dateInTimeZone.millisecond();

      // Create a new Date object with the extracted components
      const newDateObject = new Date(year, month, day, hour, minute, second, millisecond);
      return newDateObject;
    },
    compressAndConvertToWebP(dataUrl, quality = 0.7, maxWidth = 1280) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;

          // Resize if wider than maxWidth while maintaining aspect ratio
          if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);

          const webpDataUrl = canvas.toDataURL('image/webp', quality);
          resolve(webpDataUrl);
        };
        img.onerror = (err) => reject(err);
        img.src = dataUrl;
      });
    },
  },
  watch: {
    'selected_account.account_id': function () {
      this.account = this.accounts.filter(
        (account) => account.id === this.selected_account.account_id,
      );
    },
  },
  computed: {
    currentTime() {
      return moment(this.createDateWithTimeZone()).format('lll');
    },
  },
  async mounted() {
    this.fetchAccounts();
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    if (authUser && !authUser.is_verified) {
      this.$router.push('/auth/verify');
    }
  },
};
</script>
<style scoped>
.image-container {
  width: 200px;
  height: 200px;
}

.image-container img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.number-container {
  border-radius: 5px;
  /* background: rgba(255, 255, 255, 0.2) !important; */
  justify-content: center;
}

.custom-file {
  height: auto;
}
</style>
